import * as React from 'react';
import './index.css';
import PaymentPlateHead from './PaymentPlateHead';
import PaymentPlateCompany from './PaymentPlateCompany';
import { PaymentPlateGoods, PaymentPlateGoodsVirtualized } from './PaymentPlateGoods';
import PaymentPlateDetails from './PaymentPlateDetails';
export default function paymentPlate(props) {
    var paymentData = props.paymentData, paymentDataColumns = props.paymentDataColumns, paymentCompanyData = props.paymentCompanyData, goodsColumns = props.goodsColumns, goodsData = props.goodsData, detailsData = props.detailsData, otherElement = props.otherElement, isVirtualized = props.isVirtualized;
    return (React.createElement("div", { className: 'payment_plate_box' },
        React.createElement(PaymentPlateHead, { paymentData: paymentData, paymentDataColumns: paymentDataColumns }),
        React.createElement(PaymentPlateCompany, { paymentCompanyData: paymentCompanyData }),
        isVirtualized === true ?
            React.createElement(PaymentPlateGoodsVirtualized, { goodsColumns: goodsColumns, goodsData: goodsData }) :
            React.createElement(PaymentPlateGoods, { goodsColumns: goodsColumns, goodsData: goodsData }),
        React.createElement(PaymentPlateDetails, { detailsData: detailsData }),
        otherElement));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/PaymentPlate/index.js
// module id = 4217
// module chunks = 0